import { Box, Theme, useTheme } from "@mui/material";
import Slider from "react-infinite-logo-slider";
import { usePartners } from "services/hooks/usePartner";

const Partners = () => {
  const theme: Theme = useTheme();
  const { data = [] } = usePartners();

  return (
    <Box
      bgcolor={theme.palette.common.white}
      paddingY={1}
      position="fixed"
      top={0}
      left={0}
      zIndex={1000}
      boxShadow={theme.shadows[4]}
      width="100%"
      display="flex"
      justifyContent="center"
    >
      <Slider
        width="90px"
        duration={40}
        pauseOnHover={true}
        blurBorders={false}
      >
        {data.map((partner: Partner, index: number) => (
          <Slider.Slide key={index}>
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}${partner.logo?.url}`}
              alt={partner.name ?? ""}
              height={36}
              width={90}
              style={{
                paddingInline: theme.spacing(2),
                objectFit: "contain",
              }}
            />
          </Slider.Slide>
        ))}
      </Slider>
    </Box>
  );
};

export default Partners;
